import { deriveStatusName } from '../../../../utils';

export * from './appointment_deleted';
export * from './appointment_rescheduled';
export * from './appointment_scheduled';
export * from './appointment_started';
export * from './appointment_updated';
export * from './assign_estimator';
export * from './assign_installer';
export * from './auto_note';
export * from './check_in_measurement';
export * from './checkin';
export * from './coc_signed';
export * from './communication';
export * from './complete_repair';
export * from './contact_customer';
export * from './customer_survey_updated';
export * from './due_date_updated';
export * from './flag_added';
export * from './floor_wizard';
export * from './laborsheet_approved';
export * from './lowes_invoiced';
export * from './note';
export * from './override_status';
export * from './phase_canceled';
export * from './phase_completed';
export * from './phase_created';
export * from './refigure_request';
export * from './rocky';
export * from './select_assessment';
export * from './send_to_store';
export * from './communication_sent';
export * from './communication_error';
export * from './communication_received';
export * from './force_to_scheduling';
export * from './departed_from_appointment';
export * from './customer_callback_migration';

export const getStatusUsingWindow = (phase, status) => {
  const { type = '', source = '', workroom_name: phaseWorkroom = '',
          workroom: { name: workroom = '' } = {} } = phase || {};
  const statusName = (window.SPOT.status_titles[type.toLowerCase()]
                                 .status[status.toLowerCase()] || (status || '')).toLowerCase();
  return deriveStatusName(statusName, { source, workroom: phaseWorkroom || workroom });
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/index.js